import shape from "../../assets/img/shapes/frame-shape-02.webp";


const FrameShape02 = () => {

    return (
        <div className="rmdr-frame-shape-02">
            <img src={shape} alt="rmdr-frame-shape-02" loading="lazy" width={214} height={210} />
        </div>
    )

}

export default FrameShape02;
